import React, { createContext, useContext, ReactNode, useState, Dispatch, SetStateAction } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { api } from '../../AxiosConfig';

interface CreateAccountContextProps {
    loading: boolean;
    setLoading: (v: boolean) => void;
    setCreateAccount: Dispatch<SetStateAction<boolean>>;
    handleSubmitAccountClient: (doc: { name: string; email: string }) => void;
    handleSubmitAccountEstab: (doc: {
        estabName: string;
        userName: string;
        userEmail: string;
        tipo: string;
    }) => void;
    returnAction: () => void;
    sentToEmail: string;
}

const CreateAccountContext = createContext<CreateAccountContextProps | undefined>(undefined);

const CreateAccountProvider: React.FC<{
    children: ReactNode;
    setCreateAccount: Dispatch<SetStateAction<boolean>>;
    estabId?: string;
}> = ({ children, setCreateAccount, estabId }) => {
    const [loading, setLoading] = useState(false);
    // E-mail que recebeu o link de ativacao; exibe a confirmacao no lugar do formulario.
    const [sentToEmail, setSentToEmail] = useState('');
    const { errorSnackbar } = useAppContext();

    const handleSubmitAccountClient = async ({ name, email }: { name: string; email: string }) => {
        try {
            setLoading(true);
            await api.post('create-account', {
                userName: name,
                userEmail: email,
                estabId
            });
            setSentToEmail(email);
        } catch (error: any) {
            errorSnackbar(error?.response?.data?.message || 'Ocorreu um erro ao criar a conta.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitAccountEstab = async (doc: {
        estabName: string;
        userName: string;
        userEmail: string;
        tipo: string;
    }) => {
        if (estabId) return;
        try {
            setLoading(true);
            await api.post('create-account', doc);
            setSentToEmail(doc.userEmail);
        } catch (error: any) {
            errorSnackbar(error?.response?.data?.message || 'Ocorreu um erro ao criar a conta.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const returnAction = () => {
        setCreateAccount(false);
    };

    return (
        <CreateAccountContext.Provider
            value={{
                setCreateAccount,
                loading,
                setLoading,
                handleSubmitAccountClient,
                returnAction,
                handleSubmitAccountEstab,
                sentToEmail,
            }}
        >
            {children}
        </CreateAccountContext.Provider>
    );
};

const useCreateAccountContext = () => {
    const context = useContext(CreateAccountContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};

export { CreateAccountProvider, useCreateAccountContext };
